<template>
  <div>
    <button
      type="button"
      class="btn btn-primary btn-with-addon"
      @click="showModal"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-plus-circle" />
      </span>
      Category
    </button>

    <a-modal v-model="visible" title="Add Discipline Category">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit">
          Add Category
        </a-button>
      </template>

      <a-form class="mb-4" :form="form">
        <a-form-item label="Name">
          <a-input
            v-decorator="[
              'name',
              { rules: [{ required: true, message: 'Please enter name' }] },
            ]"
          />
        </a-form-item>

        <a-form-item label="Description">
          <a-input v-decorator="['description']" />
        </a-form-item>

        <a-form-item label="Active">
          <a-checkbox v-decorator="['active', { valuePropName: 'checked', initialValue: true }]">
            Active
          </a-checkbox>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'AddCategory',
  data() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
    }
  },
  methods: {
    showModal() {
      this.visible = true
    },
    handleSubmit() {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Add "${values.name}" category?`,
            content: 'Click OK to confirm.',
            onOk: () => {
              this.$http
                .post('/api/student-discipline-category', {
                  name: values.name,
                  description: values.description,
                  active: values.active ? 1 : 0,
                })
                .then(({ data }) => {
                  this.loading = false
                  this.visible = false
                  this.$emit('created')
                  this.$notification.success({
                    message: 'Category Added',
                    description: `${data.name} added successfully.`,
                  })
                  this.form.resetFields()
                })
                .catch((error) => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        } else {
          this.loading = false
        }
      })
    },
    handleCancel() {
      this.visible = false
    },
  },
}
</script>
